import Echo from 'laravel-echo'
import config from '../config'
import Cookies from 'js-cookie'
import io from 'socket.io-client'
import { loginSuccess as loginSuccessAction } from '../store/sharedActions'

export {
  logout,
  setTurnServer,
  setAccessToken,
  setUser,
  reduceMessage,
} from '../store/slices/connectionSlice'

// loginSuccess keeps its original signature and the side-effecting Echo/socket
// construction here (laravel-echo + socket.io are runtime-only). The resulting
// echoServer is handed to the shared loginSuccess action that the connection and
// chat slices both react to.
export const loginSuccess = (user, accessToken) => {
  const echoServer = new Echo({
    broadcaster: 'socket.io',
    host: config.SOCKET_ENDPOINT,
    client: io,
    // Skip the default HTTP long-polling handshake and connect straight over
    // WebSocket. Polling-first adds several round-trips before the transport
    // upgrades, which slows the realtime signaling (offer/answer/ICE whispers).
    // WebSocket is required for the calls anyway, so go direct.
    transports: ['websocket'],
    auth: {
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + (accessToken || Cookies.get('accessToken')),
      },
    },
  })

  return loginSuccessAction(user, echoServer)
}
